import { FlowDefinition } from "../../interfaces/FlowInterfaces";
import { IAdminVolunteerRegistrationFlowValues } from "../_interfaces/IAdminVolunteerRegistrationFlowValues";
import { VolunteerRegistrationFlowExternalState } from "../_interfaces/IAdminVolunteerRegistrationStepTypeValues";
import { OffsetSelectionStep } from "../components/steps/OffsetSelectionStep";
import { ViewVolunteersStep } from "../components/steps/ViewVolunteersStep";
import { VolunteerSelectionStep } from "../components/steps/VolunteerSelectionStep";

export type StepIds =
  | "volunteerSelection"
  | "viewVolunteers"
  | "offsetSelection";

export const AdminVolunteerRegistrationFlowDefinition: FlowDefinition<
  StepIds,
  IAdminVolunteerRegistrationFlowValues,
  VolunteerRegistrationFlowExternalState
> = {
  initialStep: "volunteerSelection",
  steps: {

    volunteerSelection: {
      id: "volunteerSelection",
      render: VolunteerSelectionStep,
      // isComplete: (v) => ({
      //   valid: !!v.username,
      //   reason: "Please enter a username",
      // }),
      onSubmit: (v) => {
        if (v.succeeded) {
          return { type: "end" }
        } else if (v.viewVolunteers) {
          return { type: "goto", stepId: "viewVolunteers" }
        } else {
          return { type: "goto", stepId: "offsetSelection" }
        }
      }
    },

    viewVolunteers: {
      id: "viewVolunteers",
      render: ViewVolunteersStep,
      onSubmit: (v) => {
        if (v.backClicked || !v.viewVolunteers) {
          return { type: "goto", stepId: "volunteerSelection" }
        } else if (v.succeeded) {
          return { type: "end" }
        } else {
          return { type: "goto", stepId: "offsetSelection" }
        }
      }
    },

    offsetSelection: {
      id: "offsetSelection",
      render: OffsetSelectionStep,
      onSubmit: (v) => {
        if (v.backClicked) {
          if (v.viewVolunteers) {
            return { type: "goto", stepId: "viewVolunteers" }
          } else {
            return { type: "goto", stepId: "volunteerSelection" }
          }
        }
        return { type: "end" }
      }
    },
  },
};
